import React from "react";
import styled from "styled-components";
import { RobotoFontWrapper } from "../IPWebsiteRedesign/RobotoFont";
import Arrow from "../IPWebsiteRedesign/images/upArrow.svg";
import { userTrack } from "../Common";
import getConfig from "next/config";

const Title = styled.div`
  font-family: Roboto;
  font-size: 60px;
  font-weight: 300;
  line-height: 70px;
  letter-spacing: -1.02px;
  text-align: center;
  color: #000;

  @media screen and (max-width: 767px) {
    font-size: 35px;
    line-height: 51px;
  }
`;

const MainContainer = styled.div`
  margin-top: 100px;
  margin-bottom: 100px;
`;

const CardWrapper = styled.div`
  margin-top: 50px;
  justify-content: center;
  display: flex;
  align-items: center;
  gap: 15px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

const Card1 = styled.div`
  border-radius: 12px;
  width: 280px;
  height: 180px;
  opacity: 0px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    background-color: ${(props) => props.hovercolor} !important;
  }
`;

const CardHeader1 = styled.div`
  font-family: Roboto;
  font-size: 19.15px;
  font-weight: 400;
  line-height: 33.81px;
  letter-spacing: -0.65px;
  text-align: left;
  color: #15803d;
  margin-top: 30px;
  margin-left: 20px;
`;



const CardDtl = styled.div`
  font-family: Roboto;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  margin-left: 20px;
  color: #000000;
  margin-top: 30px;
  margin-bottom: 20px;
`;

const ExlpreBtn = styled.div`
  margin-left: 20px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: #171717;
  margin-bottom: 20px;
`;

const Img = styled.img`
  width: 13px;
  position: relative;
  left: 8px;
`;

export function Cards(props) {

  const { publicRuntimeConfig } = getConfig();

  var cardData;
  if (props.Teams) {
    cardData = [
      { title: "Corporate & Strategy" },
      { title: "R&D and Technology Scouting" },
      { title: "Sales & Marketing" },
      { title: "CVC and M&A" },
      { title: "New Business Development" },
    ];
  } else {
    cardData = [
      { title: "Market Analysis" },
      { title: "Technology Analysis" },
      { title: "New Business Creation" },
      { title: "New Product Development" },
      { title: "Application Use case Analysis" },
    ];
  }

  const ColorData = [
    { bgColor: "#DCFCE7", color: "#136130", hoverColor: "#B5FFCE" },
    { bgColor: "#E0EDFF", color: "#303A92", hoverColor: "#BCD8FF" },
    { bgColor: "#FBE2CA", color: "#A75E17", hoverColor: "#FFD3A8" },
    { bgColor: "#E1FFFE", color: "#079995", hoverColor: "#C2FFFF" },
  ];

  const HandleLink = async (Title) => {
    await userTrack("", `Onclick of Card on ${Title}`, "HomePage");
    if (props.Teams) {
      if (Title === "Corporate & Strategy") {
        window.location.href = process.env.NODE_ENV == "development" ? "/Team/Corporate-Strategy" : publicRuntimeConfig.assetPrefix + "/Team/Corporate-Strategy.html";
      }
      if (Title === "R&D and Technology Scouting") {
        window.location.href = process.env.NODE_ENV == "development" ? "/Team/R&D-and-Tech-Scouting" : publicRuntimeConfig.assetPrefix + "/Team/R&D-and-Tech-Scouting.html";
      }
      if (Title === "Sales & Marketing") {
        window.location.href = process.env.NODE_ENV == "development" ? "/Team/Sales-and-Marketing" : publicRuntimeConfig.assetPrefix + "/Team/Sales-and-Marketing.html";
      }
      if (Title === "CVC and M&A") {
        window.location.href = process.env.NODE_ENV == "development" ? "/Team/CVC-and-M&A" : publicRuntimeConfig.assetPrefix + "/Team/CVC-and-M&A.html";
      }
      if (Title === "New Business Development") {
        window.location.href = process.env.NODE_ENV == "development" ? "/Team/New-Business-Development" : publicRuntimeConfig.assetPrefix + "/Team/New-Business-Development.html";
      }
    } else {
      if (Title === "Market Analysis") {
        window.location.href = process.env.NODE_ENV == "development" ? "/ResearchGoal/Market-Analysis" : publicRuntimeConfig.assetPrefix + "/ResearchGoal/Market-Analysis.html";
      }
      if (Title === "Technology Analysis") {
        window.location.href = process.env.NODE_ENV == "development" ? "/ResearchGoal/Technology-Analysis" : publicRuntimeConfig.assetPrefix + "/ResearchGoal/Technology-Analysis.html";
      }
      if (Title === "New Business Creation") {
        window.location.href = process.env.NODE_ENV == "development" ? "/ResearchGoal/New-Business-Creation" : publicRuntimeConfig.assetPrefix + "/ResearchGoal/New-Business-Creation.html";
      }
      if (Title === "New Product Development") {
        window.location.href = process.env.NODE_ENV == "development" ? "/ResearchGoal/New-Product-Development" : publicRuntimeConfig.assetPrefix + "/ResearchGoal/New-Product-Development.html";
      }
      if (Title === "Application Use case Analysis") {
        window.location.href = process.env.NODE_ENV == "development" ? "/ResearchGoal/Use-Case-Analysis" : publicRuntimeConfig.assetPrefix + "/ResearchGoal/Use-Case-Analysis.html";
      }
    }
  };

  return (
    <RobotoFontWrapper>
      <MainContainer>
        <Title>
          {!props.Teams ? (
            <>
              Explore other
              <br />
              Research Solutions
            </>
          ) : (
            <>
              Explore Solutions
              <br />
              for other teams
            </>
          )}
        </Title>

        <CardWrapper>
          {cardData
            .filter((match) => match.title !== props.title)
            .map((card, index) => (
              <Card1
                key={index}
                onClick={() => HandleLink(card.title)}
                hovercolor={ColorData[index].hoverColor}
                style={{ backgroundColor: ColorData[index].bgColor }}
              >
                <CardHeader1 style={{ color: ColorData[index].color }}>
                  {card.title}
                </CardHeader1>
                <CardDtl></CardDtl>
                <ExlpreBtn>
                  Explore
                  <span>
                    <Img alt="Arrow" src={Arrow.src}></Img>
                  </span>
                </ExlpreBtn>
              </Card1>
            ))}
        </CardWrapper>
      </MainContainer>
    </RobotoFontWrapper>
  );
}
